exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-2826ca00]{width:350px !important;height:40px}.fa[data-v-2826ca00]{color:#0a6aa1;display:block}.sheng[data-v-2826ca00]{color:red;display:block}", ""]);

// exports
